// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nHus","footer":"styles_footer__1I22J"};